import { format, formatDistanceToNow, type Locale } from 'date-fns';
import { enUS, es } from 'date-fns/locale';
import i18n from '../i18n';

const locales: Record<string, Locale> = {
  en: enUS,
  es: es,
};

function getLocale(): Locale {
  const lang = i18n.language?.split('-')[0] || 'en';
  return locales[lang] || enUS;
}

export function formatRelativeTime(date: Date | string | null | undefined): string {
  if (!date) return i18n.t('time.noActivity');
  const d = typeof date === 'string' ? new Date(date) : date;
  if (isNaN(d.getTime())) return i18n.t('time.noActivity');
  return formatDistanceToNow(d, { addSuffix: true, locale: getLocale() });
}

export function formatDate(date: Date | string, formatStr: string = 'PP'): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return format(d, formatStr, { locale: getLocale() });
}

export function formatShortDate(dateString: string | null | undefined): string {
  if (!dateString) return '-';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '-';
  const now = new Date();
  const showYear = date.getFullYear() !== now.getFullYear();

  return format(date, showYear ? 'MMM d, yyyy' : 'MMM d', { locale: getLocale() });
}

export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
}
